export default {
  state: {
    phones: [],
    phone: {
      debtor: {
        fullname: '',
      },
      contact_face: {
        fullname: '',
      },
      phone: '',
    },
    calls: [],
    callsTableData: {
      length: 10,
    },
  },
  mutations: {
    SET_PHONES(state, payload) {
      state.phones = payload.phones;
    },

    SET_CALLS(state, payload) {
      state.calls = payload.calls;
    },
    INIT_PHONE(state, payload) {
      state.phone.id = payload.id;
      state.phone.phone = payload.phone;
      if (payload.debtor) {
        state.phone.contact_face = {};
        state.phone.debtor.fullname = payload.debtor.fullname;
      }
      if (payload.contact_face) {
        state.phone.debtor = {};
        state.phone.contact_face.fullname = payload.contact_face.fullname;
      }
    },
    STORE_PHONE(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
    STORE_CALL_PHONE(state, { msg }) {
      window.Swal.fire('Успешно выполнено!', msg, 'success');
    },
  },
  actions: {
    async GET_PHONES({ commit }, payload) {
      try {
        const { data } = await window.axios.get(`/debtor/${payload}/all/phones`);
        commit('SET_PHONES', data);
      } catch (err) {
        throw err;
      }
    },
    async GET_CALLS({ commit, state }, payload) {
      try {
        const requests = { ...state.callsTableData };
        const { data } = await window.axios.get(`/debtor/${payload}/all/calls`, { params: requests });
        commit('SET_CALLS', data);
      } catch (err) {
        throw err;
      }
    },
    async INIT_PHONE({ commit }, payload) {
      try {
        commit('INIT_PHONE', payload);
      } catch (err) {
        throw err;
      }
    },
    async STORE_PHONE({ commit }, payload) {
      try {
        let url = '';
        const { debtor_iin } = payload;
        if (payload.is_debtor) {
          url = `/debtor/phones/${debtor_iin}`;
        } else {
          url = `/debtor/contactfaces/phones/${debtor_iin}`;
        }
        const { data } = await window.axios.post(url, payload);
        commit('STORE_PHONE', data);
      } catch (err) {
        throw err;
      }
    },
    async STORE_CALL_PHONE({ commit }, payload) {
      try {
        let url = '';
        const { debt_id } = payload;
        if (payload.is_debtor) {
          url = `/debtor/calls/${debt_id}`;
        } else {
          url = `/debtor/calls/contactface/${debt_id}`;
        }
        const { data } = await window.axios.post(url, payload);
        commit('STORE_CALL_PHONE', data);
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    calls(state) {
      return state.calls;
    },
    callsTableData(state) {
      return state.callsTableData;
    },
    phones(state) {
      return state.phones;
    },
    phone(state) {
      return state.phone;
    },
  },
};
